import React from 'react';

import { Icon } from '../IconExporter';
import { Container } from './styles';

type CardPreviewProps = {
  url: string;
}

export const CardPreview = ({ url }: CardPreviewProps) => {
  return <Container>
   <header>
      <div> 
        <Icon name="www" size={22} />
        <p>PRÉ VISUALIZAÇÃO</p>
      </div>
      <div>
        <Icon name="editline" size={22} />
        <Icon name="select" size={22} />
        <Icon name="cut" size={22} />
      </div>
   </header>
   <section>
    <iframe title="cardPreview iframe" src={url} />
   </section>
  </Container>
}